import { RuntimeType } from "../models/runtime";

export const getRuntime = (): RuntimeType => {
  const { diagnostics, document } = Office.context;

  if (diagnostics.platform !== Office.PlatformType.OfficeOnline) {
    // Standalone Word App
    return RuntimeType.localWord;
  }
  if ((diagnostics.platform === Office.PlatformType.OfficeOnline) && document.url === '') {
    // ITP in browser
    return RuntimeType.itp;
  }

  return RuntimeType.onlineWord;
};
